/**
 * @generated SignedSource<<adc6ff83ba0a8b04c18068f449c73705>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useMaintenanceTicketsRelayByIdQuery$variables = {
  id: string;
};
export type useMaintenanceTicketsRelayByIdQuery$data = {
  readonly getMaintenanceTicket: {
    readonly assignee: string | null | undefined;
    readonly assigneeUser: {
      readonly email: string;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null | undefined;
    readonly canceledOn: any | null | undefined;
    readonly communicationLog: ReadonlyArray<any> | null | undefined;
    readonly completedOn: any | null | undefined;
    readonly createdOn: any;
    readonly description: string;
    readonly dueOn: any;
    readonly errorReport: {
      readonly id: string;
    } | null | undefined;
    readonly errorReportOldId: string | null | undefined;
    readonly hardware: {
      readonly hardwareProduct: {
        readonly id: string;
        readonly primaryIdentifier: string | null | undefined;
      } | null | undefined;
      readonly hardwareType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly imei: string | null | undefined;
      readonly label: string | null | undefined;
      readonly location: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly mac: string | null | undefined;
      readonly number: number | null | undefined;
      readonly oldId: string | null | undefined;
      readonly vendorSerial: string | null | undefined;
    } | null | undefined;
    readonly hardwareOldId: string | null | undefined;
    readonly id: string;
    readonly images: ReadonlyArray<any> | null | undefined;
    readonly maintenanceTask: {
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly oldId: string | null | undefined;
      readonly taskType: string | null | undefined;
    } | null | undefined;
    readonly maintenanceTaskId: string;
    readonly oldId: string | null | undefined;
    readonly organizationId: string | null | undefined;
    readonly priority: number;
    readonly rental: {
      readonly id: string;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly rentalOldId: string | null | undefined;
    readonly reporter: string | null | undefined;
    readonly reporterUser: {
      readonly email: string;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null | undefined;
    readonly sourceType: string;
    readonly status: string | null | undefined;
    readonly system: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly systemId: string | null | undefined;
    readonly systemOldId: string;
    readonly tags: ReadonlyArray<string> | null | undefined;
    readonly usageProgress: {
      readonly current: number;
      readonly threshold: number;
      readonly ticketCreatedOn: any | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useMaintenanceTicketsRelayByIdQuery = {
  response: useMaintenanceTicketsRelayByIdQuery$data;
  variables: useMaintenanceTicketsRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v1/*: any*/),
  (v5/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MaintenanceTicket",
    "kind": "LinkedField",
    "name": "getMaintenanceTicket",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignee",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canceledOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "communicationLog",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dueOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorReportOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SupportTicket",
        "kind": "LinkedField",
        "name": "errorReport",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hardwareOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maintenanceTaskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priority",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rentalOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reporter",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tags",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "images",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminUser",
        "kind": "LinkedField",
        "name": "assigneeUser",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminUser",
        "kind": "LinkedField",
        "name": "reporterUser",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Hardware",
        "kind": "LinkedField",
        "name": "hardware",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "number",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mac",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imei",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vendorSerial",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareType",
            "kind": "LinkedField",
            "name": "hardwareType",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareProduct",
            "kind": "LinkedField",
            "name": "hardwareProduct",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryIdentifier",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Location",
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MaintenanceTask",
        "kind": "LinkedField",
        "name": "maintenanceTask",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v5/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskType",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Rental",
        "kind": "LinkedField",
        "name": "rental",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "System",
        "kind": "LinkedField",
        "name": "system",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MaintenanceTicketUsageProgress",
        "kind": "LinkedField",
        "name": "usageProgress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "current",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ticketCreatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMaintenanceTicketsRelayByIdQuery",
    "selections": (v7/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMaintenanceTicketsRelayByIdQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "dd20f579c493c55810b0bfaf9e4ac025",
    "id": null,
    "metadata": {},
    "name": "useMaintenanceTicketsRelayByIdQuery",
    "operationKind": "query",
    "text": "query useMaintenanceTicketsRelayByIdQuery(\n  $id: ID!\n) {\n  getMaintenanceTicket(id: $id) {\n    id\n    oldId\n    assignee\n    canceledOn\n    communicationLog\n    completedOn\n    createdOn\n    description\n    dueOn\n    errorReportOldId\n    errorReport {\n      id\n    }\n    hardwareOldId\n    maintenanceTaskId\n    organizationId\n    priority\n    rentalOldId\n    reporter\n    sourceType\n    status\n    systemId\n    systemOldId\n    tags\n    images\n    assigneeUser {\n      id\n      email\n      firstName\n      lastName\n    }\n    reporterUser {\n      id\n      email\n      firstName\n      lastName\n    }\n    hardware {\n      id\n      oldId\n      number\n      mac\n      imei\n      vendorSerial\n      label\n      hardwareType {\n        id\n        name\n      }\n      hardwareProduct {\n        id\n        primaryIdentifier\n      }\n      location {\n        id\n        name\n      }\n    }\n    maintenanceTask {\n      id\n      oldId\n      name\n      description\n      taskType\n    }\n    rental {\n      id\n      oldId\n    }\n    system {\n      id\n      oldId\n      name\n    }\n    usageProgress {\n      current\n      threshold\n      ticketCreatedOn\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "164330b9fa89680080778fcdb3e06a01";

export default node;
